import React from "react";
import "./NabhNahlAccr.css"; // Using the same CSS file
import dueDiligence from "../image/dueDiligence.jpg";

function DueDiligence() {
  return (
    <div className="due-container">
      {/* Top Half: Background Image Section */}
      <div
        className="due-image-section"
        style={{ backgroundImage: `url(${dueDiligence})` }}
      >
        {/* Dark Overlay */}
        <div className="due-overlay"></div>

        {/* Title Over Image */}
        <h1 className="due-title">Due Diligence</h1>
      </div>

      {/* Bottom Half: Content Section */}
      <div className="due-content-section">
        <div className="due-content-wrapper">
          <p className="due-paragraph">
            Our Due Diligence service provides thorough, reliable evaluations to
            support informed decision-making. We conduct comprehensive
            assessments of financial, operational, and legal aspects,
            identifying potential risks and opportunities for your business.
            With a focus on accuracy, compliance, and strategic insight, our
            team helps you make confident decisions that safeguard your
            investments and drive sustainable growth.
          </p>
        </div>
      </div>
    </div>
  );
}

export default DueDiligence;
